
import { Component, Vue } from 'vue-property-decorator'
import VenueDetail from '@/components/company/venue/VenueDetail.vue'

@Component({
  name: 'Venue',
  components: { VenueDetail }
})
class Venue extends Vue {}

export default Venue
